const ON_DEMAND_KEY = "notarize-last-ondemand-meeting-id";
export const PATH = "/on-demand-queue";

/** Use this function to persist the latest meeting id picked up from on demand queue. */
export function writeMeetingIdCameFromOnDemand(meetingId: string) {
  window.sessionStorage.setItem(ON_DEMAND_KEY, meetingId);
}

/**
 * This is the counterpart to `writeMeetingIdCameFromOnDemand` to check if meeting was entered
 * from on demand queue.
 */
export function checkMeetingIdCameFromOnDemand(meetingId: string): boolean {
  return window.sessionStorage.getItem(ON_DEMAND_KEY) === meetingId;
}
